module.exports = __webpack_public_path__ + "static/img/acoustic.3775fca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/pack/acoustic.png
// module id = XHWo
// module chunks = 12